import { all, fork, takeLatest } from 'redux-saga/effects';

import { UPDATE_QUERY } from '../constants/ActionTypes';
import { PAGE_NUMBER_QUERY_KEY, ROWS_PER_PAGE_QUERY_KEY } from '../constants/Values';
import { setQueryParameter, removeQueryParameter } from '../util/query';

function updateQuery({
  payload: {
    queryParamsList,
    params,
    pagination: { pageNumber, size },
  },
}) {
  Object.values(queryParamsList).forEach(filterValue => {
    if (params[filterValue]) {
      setQueryParameter(filterValue, params[filterValue]);
    } else {
      removeQueryParameter(filterValue);
    }
  });

  setQueryParameter(PAGE_NUMBER_QUERY_KEY, pageNumber);
  setQueryParameter(ROWS_PER_PAGE_QUERY_KEY, size);
}

export function* updateQuerySaga() {
  yield takeLatest(UPDATE_QUERY, updateQuery);
}

export default function* rootSaga() {
  yield all([fork(updateQuerySaga)]);
}
